import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'core/common/hooks';
import { FunnelConfig } from 'core/funnel/entities';
import { getFunnelConfig, updateConfig } from 'core/funnel/store';

export const useFunnelConfig = (funnelConfig: FunnelConfig | null) => {
  const dispatch = useDispatch();
  const { config: storageConfig } = useSelector(getFunnelConfig);

  useEffect(() => {
    if (!funnelConfig) return;

    dispatch(updateConfig(funnelConfig));
  }, [dispatch, funnelConfig]);

  return {
    config: funnelConfig ?? storageConfig,
  };
};
